export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER_ITEM = 'UPDATE_USER_ITEM';
export const LOADING = 'LOADING';
export const CHANGE_STATE = "CHANGE_STATE";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const CHANGE_ADMIN_REGIME = "CHANGE_ADMIN_REGIME";
